// NoMunch cart upsell: "Upgrade and Save" converts a one-time line to a subscription
// (Appstle selling plan) via /cart/change.js, then morphs the open cart drawer in place.
import { morphSection } from '@theme/section-renderer';

const SECTION_ID = 'cart-drawer-section';

function cartChangeUrl() {
  if (window.Theme && Theme.routes && Theme.routes.cart_change_url) return Theme.routes.cart_change_url;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  return `${root}cart/change.js`;
}

document.addEventListener('click', (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-nm-upgrade]') : null;
  if (!btn) return;
  event.preventDefault();
  if (btn.hasAttribute('aria-busy')) return;
  btn.setAttribute('aria-busy', 'true');

  const body = JSON.stringify({
    id: btn.getAttribute('data-line-key'),
    quantity: parseInt(btn.getAttribute('data-qty'), 10) || 1,
    selling_plan: btn.getAttribute('data-plan'),
    sections: SECTION_ID,
    sections_url: window.location.pathname,
  });

  fetch(cartChangeUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body,
  })
    .then((response) => response.json())
    .then((data) => {
      const html = data && data.sections && data.sections[SECTION_ID];
      if (html) {
        morphSection(SECTION_ID, html, { mode: 'hydration' });
      } else {
        window.location.reload();
      }
    })
    .catch(() => {
      btn.removeAttribute('aria-busy');
    });
});
